export default function debounce(f, ms) {
    let timer = null;

    return function () {
        let args = arguments;

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => {
            f.apply(this, args);
            timer = null;
        }, ms);
    };
}
